'use strict';

var typography = require('../../../../../../../../../../_virtual/typography3.cjs');

var hasRequiredTypography;

function requireTypography () {
	if (hasRequiredTypography) return typography.__exports;
	hasRequiredTypography = 1;

	var TYPOGRAPHY_FONT_WEIGHTS = /*#__PURE__*/ function(TYPOGRAPHY_FONT_WEIGHTS) {
	    TYPOGRAPHY_FONT_WEIGHTS["regular"] = "regular";
	    TYPOGRAPHY_FONT_WEIGHTS["bold"] = "bold";
	    return TYPOGRAPHY_FONT_WEIGHTS;
	}({});

	typography.__exports.TYPOGRAPHY_FONT_WEIGHTS = TYPOGRAPHY_FONT_WEIGHTS;
	
	return typography.__exports;
}

exports.__require = requireTypography;
//# sourceMappingURL=typography.cjs.map
